import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import HttpClient from '../../utils/HttpClient';

//get Page enquiries'
export const fetchAnalyticsBasicDetails = createAsyncThunk('Data/AnalyticsBasicDetails', async () => {
    const response = await HttpClient.requestData("analytics", "GET", {})
    return response;
});

//get Post enquiries'
export const fetchAnalyticsFollowers = createAsyncThunk('Data/AnalyticsFollowers', async () => {
    const response = await HttpClient.requestData("all-followers", "GET", {});// 
    return response.data;
});

//get Post enquiries'
export const fetchAnalyticsActivities = createAsyncThunk('Data/AnalyticsActivities', async () => {
    const response = await HttpClient.requestData("all-activities", "GET", {});
    return response.data;
});

//get Report'
export const fetchAnalyticsReportOverview = createAsyncThunk('Data/AnalyticsReportOverview', async () => {
    const response = await HttpClient.requestData("overview-analytics", "GET", {});
    return response;
});

//get Profile Report'
export const fetchAnalyticsProfileReport = createAsyncThunk('Data/AnalyticsProfileReport', async () => {
    const response = await HttpClient.requestData("profile-analytics", "GET", {});
    return response;
});


// Create the Data slice
const analyticsSlice = createSlice({
    name: 'AnalyticsData',
    initialState: {
        AnalyticsBasicDetails: {},
        AnalyticsFollowers: [],
        AnalyticsActivities: [],
        AnalyticsReportOverview: {
            TotalLikeCount: 0,
            TotalReachedCount: 0,
            TotalEngagededCount: 0,
            TotalMembersCount: 0,
            TotalNonMembersCount: 0,
            LikedData: [],
            ReachedData: [],
            ProfileLikedData: [],
            PageVisitData: [],
            EngagededData: [],
            ConnectionData: [],
        },
        AnalyticsProfileReport: {
            TotalMembersCount: 0,
            TotalNonMembersCount: 0,
            TotalLikeCount: 0,
            totalProfileAvgRating: 0,
            hitsData: [],
            allFollowersData: [],
        },
        AnalyticsStatus: '',
        error: null,
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // Fetching My Business Page Enquiry Data
            .addCase(fetchAnalyticsBasicDetails.pending, (state) => {
                state.AnalyticsStatus = 'loading';
            })
            .addCase(fetchAnalyticsBasicDetails.fulfilled, (state, action) => {
                state.AnalyticsStatus = 'succeeded';
                state.AnalyticsBasicDetails = action?.payload;
            })
            .addCase(fetchAnalyticsBasicDetails.rejected, (state, action) => {
                state.AnalyticsStatus = 'failed';
                state.AnalyticsBasicDetails = null;
                state.error = action?.error.message;
            })

            // Fetching My Business Posts Enquiry Data
            .addCase(fetchAnalyticsFollowers.pending, (state) => {
                state.AnalyticsStatus = 'loading';
            })
            .addCase(fetchAnalyticsFollowers.fulfilled, (state, action) => {
                state.AnalyticsStatus = 'succeeded';
                state.AnalyticsFollowers = action?.payload
                    // .filter((item)=>{return item.PostData})
                    .sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn))

            })
            .addCase(fetchAnalyticsFollowers.rejected, (state, action) => {
                state.AnalyticsStatus = 'failed';
                state.AnalyticsFollowers = null;
                state.error = action?.error.message;
            })

            // Fetching My Business Posts Enquiry Data
            .addCase(fetchAnalyticsActivities.pending, (state) => {
                state.AnalyticsStatus = 'loading';
            })
            .addCase(fetchAnalyticsActivities.fulfilled, (state, action) => {
                state.AnalyticsStatus = 'succeeded';
                const data = action?.payload[0];
                const activityData = [
                    ...data.likedData.map((item) => ({
                        ...item,
                        activityType: "like"
                    })),
                    ...data.followerData.map((item) => ({
                        ...item,
                        activityType: "follow"
                    })),
                    ...data?.pageViewData?.map((item) => ({
                        ...item,
                        activityType: "visit"
                    }))
                ];

                state.AnalyticsActivities = activityData
                    // .filter((item)=>{return item.PostData})
                    .sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn))
            })
            .addCase(fetchAnalyticsActivities.rejected, (state, action) => {
                state.AnalyticsStatus = 'failed';
                state.AnalyticsFollowers = null;
                state.error = action?.error.message;
            })

            // Fetching My Analytics Overview
            .addCase(fetchAnalyticsReportOverview.pending, (state) => {
                state.AnalyticsStatus = 'loading';
            })
            .addCase(fetchAnalyticsReportOverview.fulfilled, (state, action) => {
                state.AnalyticsStatus = 'succeeded';
                state.AnalyticsReportOverview.TotalLikeCount = action?.payload?.TotalLikeCount || 0
                // state.AnalyticsReportOverview.TotalReachedCount = action?.payload?.TotalReachedCount || 0
                // state.AnalyticsReportOverview.TotalEngagededCount = action?.payload?.TotalEngagededCount || 0
                state.AnalyticsReportOverview.LikedData = action?.payload?.LikedData || []
                const combinedReachedData = [
                    ...action?.payload?.ReachedData,
                    ...action?.payload?.PageVisitData.map(item => ({ ...item, pageVisitor: true }))
                ];
                 state.AnalyticsReportOverview.TotalReachedCount = combinedReachedData?.length || 0
                state.AnalyticsReportOverview.ReachedData = combinedReachedData.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn)) || []
                // state.AnalyticsReportOverview.ReachedData = action?.payload?.ReachedData

                // EngagededData
                const combinedEngagededData = [
                    ...action?.payload?.ReachedData,
                    ...action?.payload?.PageVisitData.map(item => ({ ...item, pageVisitor: true })),
                    ...action?.payload?.LikedData.map(item => ({ ...item, profileLike: true })),
                    ...action?.payload?.LikeddData.map(item => ({ ...item, pageLike: true })),
                    ...action?.payload?.PageRatingData.map(item => ({ ...item, pageRating: true })),
                    ...action?.payload?.ProfileRatingData.map(item => ({ ...item, profileRating: true })),
                    ...action?.payload?.PageFollowData.map(item => ({ ...item, pageFollow: true })),
                    
                ];
                state.AnalyticsReportOverview.TotalEngagededCount = combinedEngagededData?.length || 0
                state.AnalyticsReportOverview.EngagededData = combinedEngagededData.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn)) || []
                state.AnalyticsReportOverview.PageVisitData = action?.payload?.PageVisitData.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn)) || []
                state.AnalyticsReportOverview.ProfileLikedData = action?.payload?.LikeddData.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn)) || []
                state.AnalyticsReportOverview.ConnectionData = action?.payload?.ConnectionData.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn)) || []
            })
            .addCase(fetchAnalyticsReportOverview.rejected, (state, action) => {
                state.AnalyticsStatus = 'failed';
                state.AnalyticsReportOverview = null;
                state.error = action?.error.message;
            })

            // Fetching My Profile Analytics
            .addCase(fetchAnalyticsProfileReport.pending, (state) => {
                state.AnalyticsStatus = 'loading';
            })
            .addCase(fetchAnalyticsProfileReport.fulfilled, (state, action) => {
                state.AnalyticsStatus = 'succeeded';
                state.AnalyticsProfileReport.TotalMembersCount = action?.payload?.TotalMembersCount || 0
                state.AnalyticsProfileReport.TotalNonMembersCount = action?.payload?.TotalNonMembersCount || 0
                state.AnalyticsProfileReport.TotalLikeCount = action?.payload?.TotalLikeCount || 0
                state.AnalyticsProfileReport.totalProfileAvgRating = action?.payload?.totalProfileAvgRating || 0
                state.AnalyticsProfileReport.hitsData = action?.payload?.HitsData || []
                state.AnalyticsProfileReport.allFollowersData = action?.payload?.HitsData?.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn)) || []
                // action?.payload?.AllFollowersData || []
            })
            .addCase(fetchAnalyticsProfileReport.rejected, (state, action) => {
                state.AnalyticsStatus = 'failed';
                state.AnalyticsProfileReport = null;
                state.error = action?.error.message;
            })
    },
});

export const { } = analyticsSlice.actions
export default analyticsSlice.reducer

// Export the asynchronous thunks for use in components or other parts of your application